import React from "react";
import moment from "moment";
import  Dialog from "@mui/material/Dialog";
import { formatDateAndTime } from "src/utils/dateAndTime";
import {RxCross2} from 'react-icons/rx'

type Prop = {
  data: any;
  onClose(): void;
};
/**
 * A flow row written before a stamp existed carries no date at all, and
 * `moment(undefined)` formats as NOW — which printed today's date on those rows
 * and put them out of order against the rows around them. Fall back to when the
 * row itself was written, which is the truth for exactly those rows, and only
 * show a dash when even that is missing.
 */
const flowDate = (value: any, format: string, fallback?: any) => {
  const when = value || fallback;
  return when ? formatDateAndTime(when, format) : "-";
};

export const applicationStatus = (el: any) => {
  switch (el?.status) {
    case "PENDING":
      return {
        className: "text-yellow-500",
        label: "Pending",
        name: el?.appliedByName,
        Date: el?.appliedOnDate,
      };
    case "IN_PROGRESS":
      return {
        className: "text-green-500",
        label: "In Progress",
        name: el?.assignedByName,
        Date:el?.assignedOnDate ,
      };
    case "FORM_FILL_PENDING":
      return {
        className: "text-violet-400",
        label: "Form Fill Pending",
        name: el?.formFillMovedByName,
        Date: el?.formFillMovedOnDate,
      };
    case "FORM_FILL_IN_PROGRESS":
      return {
        className: "text-violet-600",
        label: "Form Fill In Progress",
        name: el?.formFilledByName,
        Date: el?.formFilledOnDate,
      };
    case "REJECT":
      return {
        className: "text-red-700 ",
        label: "Reject",
        name: el?.rejectedByName,
        Date:el?.rejectedOnDate ,
      };
    case "VERIFY":
      return {
        className: "text-green-500",
        label: "Verify",
        name: el?.verifiedByName,
        Date:el?.verifiedOnDate ,
      };
    case "GENERATE":
      return {
        className: "text-green-500",
        label: "Generate",
        name: el?.generatedByName,
        Date:el?.generatedOnDate ,
      };
    case "DONE":
      return {
        className: "text-green-500",
        label: "Done",
        name: el?.completedByName,
        Date:el?.completedOnDate ,
      };
    case "CANCELLED":
      return {
        className: "text-red-700",
        label: "Cancelled",
        name: el?.cancelledByName,
        Date:el?.cancelledOnDate ,
      };
    case "COMPLETE":
      return {
        className: "text-green-500",
        label: "Complete",
        name: el?.completedByName,
        Date:el?.completedOnDate        ,
      };
    case "PAYMENT_PENDING":
      return {
        className: "text-red-700 ",
        label: "Failed",
        Date:el?.createdAt ,
      };
    case "FAILURE":
      return {
        className: "text-red-700",
        label: "Failed",
        Date:el?.createdAt ,
      };
    case "SUCCESS":
      return {
        className: "text-green-500",
        label: "Success",
        Date:el?.createdAt ,
      };
  }
};

export const applicationStatusForHistory = (el: any) => {
  // A refill / acknowledgement-reupload row keeps the application's status (it
  // did not change), so it is told apart by statusToShow.
  switch (
    ["FORM_REFILLED", "ACK_REUPLOADED"].includes(el?.statusToShow)
      ? el?.statusToShow
      : el?.status
  ) {
    case "PENDING":
      return {
        className: "text-yellow-500",
        label: "Pending",
        name:el?.moveToPendingByName === '' ?  el?.appliedByName : el?.moveToPendingByName,
        Date:el?.moveToPendingOnDate === '' ? el?.createdDateToShow    : el?.moveToPendingOnDate   ,
      };
    case "IN_PROGRESS":
      return {
        className: "text-green-500",
        label: "In Progress",
        name: el?.assignedByName,
        Date:el?.assignedOnDate ,
      };
    case "FORM_FILL_PENDING":
      return {
        className: "text-violet-400",
        label: "Form Fill Pending",
        name: el?.formFillMovedByName,
        Date: el?.formFillMovedOnDate,
      };
    case "FORM_FILL_IN_PROGRESS":
      return {
        className: "text-violet-600",
        label: "Form Fill In Progress",
        name: el?.formFilledByName,
        Date: el?.formFilledOnDate,
      };
    case "REJECT":
      return {
        className: "text-red-700 ",
        label: "Reject",
        name: el?.rejectedByName,
        Date:el?.rejectedOnDate ,
      };
    case "VERIFY":
      return {
        className: "text-green-500",
        label: "Verify",
        name: el?.verifiedByName,
        Date:el?.verifiedOnDate ,
      };
    case "GENERATE":
      return {
        className: "text-green-500",
        label: "Generate",
        name: el?.generatedByName,
        Date:el?.generatedOnDate ,
      };
    case "DONE":
      return {
        className: "text-green-500",
        label: "Done",
        name: el?.completedByName,
        Date:el?.completedOnDate ,
      };
    case "CANCELLED":
      return {
        className: "text-red-700",
        label: "Cancelled",
        name: el?.cancelledByName,
        Date:el?.cancelledOnDate ,
      };
    case "COMPLETE":
      return {
        className: "text-green-500",
        label: "Complete",
        name: el?.completedByName,
        Date:el?.completedOnDate        ,
      };
    case "PAYMENT_PENDING":
      return {
        className: "text-red-700 ",
        label: "Failed",
        Date:el?.createdAt ,
      };
    case "FAILURE":
      return {
        className: "text-red-700",
        label: "Failed",
        Date:el?.createdAt ,
      };
    case "SUCCESS":
      return {
        className: "text-green-500",
        label: "Success",
        Date:el?.createdAt ,
      };
    case "FORM_FILL_SUBMITTED":
      return {
        className: "text-violet-600",
        label: "Form Fill Submitted",
        name: el?.formFilledByName,
        Date: el?.formFilledOnDate,
      };
    case "FORM_REFILLED":
      return {
        className: "text-violet-600",
        label: "Form Refilled",
        name: el?.formRefilledByName,
        Date: el?.formRefilledOnDate || el?.createdAt,
      };
    case "ACK_REUPLOADED":
      return {
        className: "text-blue-500",
        label: "Acknowledgement Reuploaded",
        name: el?.ackReuploadedByName,
        Date: el?.ackReuploadedOnDate || el?.createdAt,
      };
    case "EMPLOYER CERTIFICATE GENERATE":
      return {
        className: "text-green-500",
        label: "Employer Certificate Generate",
        name: el?.generatedByName,
        Date:el?.createdAt ,
      };
  }
};

/**
 * The Verify row.
 *
 * Verification is its own step in every service's pipeline, but on PAN it
 * writes no flow row of its own: the acting user is stamped onto the
 * application as `verifiedBy*` while the row that gets written carries the
 * status the application MOVED to (Form Fill Pending). So the flow printed
 * Form Fill Pending under the verifier's name and never said who verified —
 * the one name the counter is asked for most often.
 *
 * The stamp is on the row, so the row it is missing from is the row it is
 * rebuilt out of: a copy carrying `status: VERIFY`, which the switch above
 * already renders as Verify / `verifiedByName` / `verifiedOnDate`.
 *
 * Skipped where the flow already holds a VERIFY row — the services that stop
 * at Verify as a status of their own, and a PAN application parked in LOGIN
 * DONE, already print exactly this row and a second one would only repeat it.
 */
const withVerifyRow = (rows: any[]) => {
  const isRealStatusRow = (el: any) =>
    !["ASSIGNEE_CHANGED", "FORM_REFILLED", "ACK_REUPLOADED"].includes(
      el?.statusToShow
    );
  if (rows.some((el) => isRealStatusRow(el) && el?.status === "VERIFY")) {
    return rows;
  }
  const at = rows.findIndex(
    (el) =>
      isRealStatusRow(el) &&
      ((el?.verifiedByName || "").trim() || (el?.verifiedOnDate || "").trim())
  );
  if (at === -1) return rows;
  const verifyRow = { ...rows[at], status: "VERIFY", statusToShow: "" };
  // Placed BEFORE the row it was taken from: verification and the hand-off it
  // triggers carry the same stamp, and a tie keeps the order the rows are in.
  return [...rows.slice(0, at), verifyRow, ...rows.slice(at)];
};

/**
 * The Form Fill Submitted row.
 *
 * Like Verify, submitting the PAN form writes no flow row of its own: the row
 * written carries the status the application moved to (Generate / Login Done)
 * under the print operator's name, while the submitter is re-stamped onto it as
 * `formFilledBy*`. After an assignee change the submitter is not the operator
 * who picked the work up, so without this row the flow never said who filled
 * the form.
 *
 * A row counts as a submit when it carries a `formFilledOnDate` that no Form
 * Fill In Progress row has — i.e. the stamp moved at submit. Older rows, stamped
 * only on pickup, match their pickup row and add nothing.
 */
const withFormSubmittedRow = (rows: any[]) => {
  const isRealStatusRow = (el: any) =>
    !["ASSIGNEE_CHANGED", "FORM_REFILLED", "ACK_REUPLOADED"].includes(
      el?.statusToShow
    );
  const pickupStamps = new Set(
    rows
      .filter(
        (el) => isRealStatusRow(el) && el?.status === "FORM_FILL_IN_PROGRESS"
      )
      .map((el) => (el?.formFilledOnDate || "").trim())
  );
  if (!pickupStamps.size) return rows;
  const out: any[] = [];
  const added = new Set<string>();
  rows.forEach((el) => {
    const stamp = (el?.formFilledOnDate || "").trim();
    if (
      isRealStatusRow(el) &&
      el?.status !== "FORM_FILL_IN_PROGRESS" &&
      stamp &&
      !pickupStamps.has(stamp) &&
      !added.has(stamp)
    ) {
      added.add(stamp);
      // Before the row it came from: same stamp, and a tie keeps this order.
      out.push({ ...el, status: "FORM_FILL_SUBMITTED", statusToShow: "" });
    }
    out.push(el);
  });
  return out;
};

/**
 * The rows in the order they happened, oldest first.
 *
 * The flow table hands them back in the order the STATUSES run, not the order
 * the work was done — and since login now happens before form fill, Verify
 * carries an earlier stamp than the Form Fill rows printed above it. The table
 * is headed Date-Time, so it has to read down in time.
 *
 * A row with no stamp of its own inherits the time of the row before it, so it
 * stays where it sits instead of jumping to the top; ties keep their original
 * order, which is the status order this used to print.
 */
const orderedRows = (rows: any) => {
  if (!Array.isArray(rows)) return [];
  let carried = 0;
  const stamped = withVerifyRow(withFormSubmittedRow(rows)).map((el: any, index: number) => {
    const when = el?.statusToShow === "ASSIGNEE_CHANGED"
        ? el?.assignedOnDate || el?.createdAt
        : applicationStatusForHistory(el)?.Date || el?.createdAt;
    const parsed = when
      ? moment(when, ["YYYY-MM-DD HH:mm:ss", moment.ISO_8601], false).valueOf()
      : NaN;
    if (!Number.isNaN(parsed)) carried = parsed;
    return { el, index, time: Number.isNaN(parsed) ? carried : parsed };
  });
  stamped.sort((a, b) => a.time - b.time || a.index - b.index);
  return stamped.map((r) => r.el);
};

const HistoryDialog = ({ data , onClose }: Prop) => {
  const rows = orderedRows(data?.data);
  return (
    <>
      <Dialog
        open={data?.data?.length ? true : false}
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "600px", // Set your width here
            },
          },
        }}
      > 
      <div className="flex justify-end pt-1 pr-2 cursor-pointer" onClick={()=>{onClose()}} > <span className=" bg-slate-400 rounded-full p-1 text-white hover:bg-red-400  transition-all" ><RxCross2 size='1.2em'  /></span> </div>
        <h3 className="flex justify-center font-semibold text-[18px] pb-2 border-b-2">
          Application Status Flow
        </h3>
        <div className="grid grid-cols-3  my-4 mx-2">
              <div className="text-[16px] border-x-2 border-t-2">
                <div className="text-[16px] border-b-2 py-1 text-center text-primary-dark font-semibold">
                Date-Time
                </div>
                <div>
                  {rows.map((el: any, ind: any) => {
                    return (
                      <div
                        key={ind}
                        className="h-16 text-center text-[14px ] border-b  pt-2"
                      >
                        <div className="text-slate-700 font-medium">
                        
                        { el?.statusToShow === "ASSIGNEE_CHANGED" ? flowDate(el?.assignedOnDate, "DD MMM yyyy", el?.createdAt)   : flowDate(
                          applicationStatusForHistory(el)?.Date,
                          "DD MMM yyyy",
                          el?.createdAt
                        )}
                      </div>
                      <div className="text-[13px] font-medium text-slate-400">
                        { el?.statusToShow === "ASSIGNEE_CHANGED" ? flowDate(el?.assignedOnDate, "hh:mm A", el?.createdAt)   : flowDate(applicationStatusForHistory(el)?.Date, "hh:mm A", el?.createdAt)}
                      </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="text-[16px] border-t-2">
                <div className="text-[16px] border-b-2 py-1 text-center font-semibold">
                  Status
                </div>
                <div>
                  {rows.map((el: any, ind: any) => {
                    return (
                      <div
                        key={ind}
                        className="h-16 text-center text-[14px ] border-b pt-2"
                      >
                        <p
                        className={`${
                          applicationStatusForHistory(el)?.className
                        } font-semibold py-[10px]`}
                      >
                        {el?.statusToShow === "ASSIGNEE_CHANGED" ?  <div className="text-[14px] font-medium text-blue-400" > Assignee change</div> : applicationStatusForHistory(el)?.label}
                      </p>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="text-[16px]  border-x-2   border-t-2 ">
                <div className="text-[16px] border-b-2 py-1 text-center font-semibold">
                  Updated By
                </div>
                <div>
                  {rows.map((el: any, ind: any) => {
                    return (
                      <div
                        key={ind}
                        className="h-16 text-center text-[14px ] border-b pt-2"
                      >
                        <p className="py-[8px]" >{el?.statusToShow === "ASSIGNEE_CHANGED" ?  <div className="text-[14px]  capitalize" >{el?.assignedByName}{el?.assignedToName ? <div className="text-[12px] text-slate-400 normal-case">to {el?.assignedToName}</div> : null} </div> :applicationStatusForHistory(el)?.name} </p>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div> 
      </Dialog>
    </>
  );
};

export default HistoryDialog;
